import { render } from "./memberAgreement.vue?vue&type=template&id=3cd4ce4c"
const script = {}

import "./memberAgreement.vue?vue&type=style&index=0&id=3cd4ce4c&lang=css"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__